export enum AutoConnectCameraStatus {
  CONNECTED = 'connected',
  FAILED = 'failed',
}

export enum CameraType {
  SMALL = 'small',
}
